import { toast } from "react-toastify";
import axiosInstance from "../../../../axiosInstance";
import { HRMS_EMPLOYEE_API_URL } from "../../../Constants/baseConstant";
import { getDomain, getUserId } from "../../Base/helper/baseFunctions";

export const GetPmsFeedbackHelper = async () => {
  return await axiosInstance(`/pms/Feedback/getPmsFeedback`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
    },
  })
    .then((res) => {
      return { message: "Feedback retrieved successfully", hasError: false, data: res?.data };
    })
    .catch((err) => {
      return { message: "Unable to retrieve feedback", hasError: true, data: err?.response?.data };
    });
};


export const AddPmsFeedbackHelper = async (params) => {
  toast.dismiss();
  toast.info("Saving...");
  return await axiosInstance(`/pms/Feedback/addPmsFeedback`, {
    method: "POST",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      feedback_title: params?.feedback_title,
      feedback_from: params?.feedback_from,
      feedback_to: params?.feedback_to,
      feedback_type: params?.feedback_type?.value,
      feedback_rating: +params?.feedback_rating,
      feedback_comments: params?.feedback_comments || "",
      visibility: params?.visibility,
      feedback_json: params?.feedback_json || "[]"
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Feedback added successfully");
      return { message: "Feedback added successfully", hasError: false, data: res?.data };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Unable to add feedback", hasError: true, data: err?.response?.data };
    });
};

export const UpdatePmsFeedbackHelper = async (params) => {
  const isReply = params?.replyToast;
  toast.dismiss();
  toast.info(isReply ? "Sending reply..." : "Updating feedback...");
  return await axiosInstance(`/pms/Feedback/updatePmsFeedback`, {
    method: "PUT",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      feedback_pk: params?.feedback_pk,
      feedback_title: params?.feedback_title,
      feedback_from: params?.feedback_from,
      feedback_to: params?.feedback_to,
      feedback_type: params?.feedback_type?.value,
      feedback_rating: +params?.feedback_rating,
      feedback_comments: params?.feedback_comments,
      feedback_json: params?.feedback_json
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success(isReply ? "Reply sent successfully" : "Feedback updated successfully");
      return { message: "Feedback updated successfully", hasError: false, data: res?.data };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Unable to update feedback", hasError: true, data: err?.response?.data };
    });
};


export const DeletePmsFeedbackHelper = async (params) => {
  toast.dismiss();
  toast.info("Deleting...");
  return await axiosInstance(`/pms/Feedback/deletePmsFeedback`, {
    method: "DELETE",
    baseURL: HRMS_EMPLOYEE_API_URL,
    data: {
      domain_name: getDomain(),
      user_id: getUserId(),
      feedback_pk: params?.feedback_pk,
    },
  })
    .then((res) => {
      toast.dismiss();
      toast.success("Feedback deleted successfully");
      return { message: "Feedback deleted successfully", hasError: false, data: res?.data };
    })
    .catch((err) => {
      toast.dismiss();
      toast.error(err?.response?.data?.error?.[0]?.message);
      return { message: "Unable to delete feedback", hasError: true, data: err?.response?.data };
    });
};
